import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-function-bar',
    templateUrl: './function-bar.component.html',
    styleUrls: ['./function-bar.component.scss']
})
export class FunctionBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
